import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Header from "./Header";
import Footer from "./Footer";

const Main = styled.main`
  padding-top: 90px;

  @media (max-width: 768px) {
    padding-top: 76px;
  }
`;

function Layout() {
  return (
    <>
      <Header /> {/* Always render the Header */}
      <Main>
        <Outlet /> {/* Render the child route component */}
      </Main>
      <Footer />
    </>
  );
}

export default Layout;
